import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/design-sync.constant";

export {
    addDesignSyncs,
    addSingleDesignSync,
    updateSingleDesignSync,
    getSingleDesignSync,
    getAllDesignSyncs,
    searchDesignSyncs,
    searchDesignSyncsWithSearchCriteria,
    prepareDesignSyncsList
}

const collectionName = 'design-syncs';
const collectionReference = collection(fireStoreDB, collectionName);

const addDesignSyncs = (designSyncs) => {
    return Promise.map(designSyncs, async designSync => {
        await addSingleDesignSync(designSync);
    });
}

const addSingleDesignSync = (designSync) => {
    designSync.createdAt = new Date();
    designSync.updatedAt = designSync.createdAt;
    return addDoc(collectionReference, designSync);
}

const updateSingleDesignSync = (designSync) => {
    const documentReference = doc(fireStoreDB, collectionName, designSync.id);
    designSync.updatedAt = new Date();
    return setDoc(documentReference, designSync);
}

const getSingleDesignSync = async (designSyncId) => {
    const documentReference = doc(fireStoreDB, collectionName, designSyncId);
    const designSyncDoc = await getDoc(documentReference);
    return prepareSingleDesignSync(designSyncDoc);
}

const getAllDesignSyncs = async () => {
    let searchQuery = query(collectionReference);
    const designSyncsResult = await getDocs(searchQuery);
    return prepareDesignSyncsList(designSyncsResult);
}

const searchDesignSyncs = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const designSyncResult = await getDocs(searchQuery);
    return prepareDesignSyncsList(designSyncResult);
}

const searchDesignSyncsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchDesignSyncsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const designSyncResult = await getDocs(searchQuery);
    return prepareDesignSyncsList(designSyncResult);
}

const prepareDesignSyncsList = (designSyncResult) => {
    const designSyncsList = [];

    _.forEach(designSyncResult.docs, designSyncDoc => {
        designSyncsList.push(prepareSingleDesignSync(designSyncDoc));
    });

    return designSyncsList;
}


const prepareSingleDesignSync = (designSyncDoc) => {
    const designSync = designSyncDoc.data();
    designSync.id = designSyncDoc.id;
    return designSync;
}
